import React from 'react'
import HireHero from '../Components/hire/HireHero'
import HireDeveloper from '../Components/hire/HireDeveloper'
import ConnectDevelopers from '../Components/hire/ConnectDevelopers'
import OurProcess from '../Components/hire/OurProcess'
import WhyChooseSection from '../Components/hire/WhyChooseSection'
import InfoGridSection from '../Components/hire/InfoGridSection'
import { motion } from 'framer-motion';
import WhyMobikode from '../Components/hire/WhyMobikode'
import EngagementModels from '../Components/hire/EngagementModels'
import HowItWorks from '../Components/hire/HowItWorks'
import { Helmet } from "react-helmet-async";

function HireDummy() {
    return (
        <div>
            <Helmet>
    <title>
        Hire Dedicated Developers | Staff Augmentation Services | Mobikode
    </title>

    <meta
        name="description"
        content="Hire skilled dedicated developers from Mobikode to extend your development team, accelerate digital projects, and build reliable, secure, and scalable software solutions with flexible engagement models."
    />

    <meta
        name="keywords"
        content="Hire Dedicated Developers, Hire Developers, Dedicated Developers, Staff Augmentation Services, IT Staff Augmentation, Software Developers for Hire, Dedicated Development Team, Offshore Development Team, Remote Developers, Hire Software Developers, Dedicated Development Services, Developer Team Augmentation, IT Outsourcing Services, Offshore Development Services, Software Development Team"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/hire-developers"
    />

    <meta
        property="og:title"
        content="Hire Dedicated Developers | Staff Augmentation Services | Mobikode"
    />

    <meta
        property="og:description"
        content="Build and scale your technology team with Mobikode's dedicated developers and staff augmentation services. Get skilled development talent that integrates seamlessly with your team."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/hire-developers"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/hire-n/img3.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Hire Dedicated Developers | Staff Augmentation Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Hire experienced developers and build flexible, scalable teams with Mobikode's dedicated development and staff augmentation services."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/hire-n/img3.png"
    />
</Helmet>
            <HireHero />
            <HireDeveloper />
            <ConnectDevelopers />
            <OurProcess />
            <WhyChooseSection />
            <InfoGridSection />
            <section className="w-full bg-gradient-to-r from-[#F0F8FF] to-[#E6F4FA] overflow-hidden font-sans">
                <div className="max-w-[1440px] mx-auto">
                    <div className="flex flex-col lg:flex-row items-center">
                        <div className="w-full lg:w-1/2 px-6 py-16 md:px-[80px] md:py-24">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            >
                                <h2 className="font-sora font-[600] leading-[1.1] mb-2">
                                    <span className="block text-[#01386A] text-[20px] lg:text-[30px]">
                                        Build Faster.
                                    </span>
                                    <span className="block text-[#ED6800] text-[20px] lg:text-[30px]">
                                        Scale Smarter.
                                    </span>
                                </h2>
                                <h3 className="text-[#0E2A62] text-[16px] md:text-[20px] font-[600] mb-[27px] font-sora">
                                    Deliver with Confidence.
                                </h3>
                                <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-relaxed font-graphik text-justify md:text-left">
                                    At Mobikode, we help businesses accelerate digital transformation by providing highly skilled, dedicated developers who seamlessly integrate with your team. Whether you need to extend your in-house capabilities or build an offshore delivery model, we provide reliable, secure, and scalable development talent tailored to your needs.
                                </p>
                            </motion.div>
                        </div>

                        <div className="w-full lg:w-1/2 h-[400px] lg:h-[600px] relative">
                            <motion.div
                                initial={{ opacity: 0, scale: 0.95 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 1 }}
                                className="w-full h-full"
                            >
                                <img
                                    src="/assets/hire-n/img3.png"
                                    alt="Build Faster Scale Smarter"
                                    className="w-full h-full object-cover object-center"
                                />
                            </motion.div>
                            <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#F0F8FF] to-transparent lg:hidden"></div>
                        </div>

                    </div>
                </div>
            </section>
            <WhyMobikode />
            <EngagementModels />
            <HowItWorks />
        </div>
    )
}

export default HireDummy
